import React, { Component } from 'react';
import { connect } from 'react-redux';


import AdminSelector from '../adminselector/adminselector';
import TreeListSplit from '../treeListSplit/treelistsplit';

 // START CLASS  //////////////////////////////////////////////////////
class Adminpage extends Component {
    constructor(props) {
        super(props);
        this.state = {
          listSelector: [
            {name:"SECURITY",icon:"lock",displayName:"Security"},
            {name:"PARAMETERS",icon:"cog",displayName:"Parameters"},
            {name:"REFERENTIAL",icon:"link",displayName:"Referential"},
            {name:"HR",icon:"user",displayName:"HR"},
            {name:"DOCUMENTS",icon:"file-alt",displayName:"Documents"},
          ],
        }
    }

    componentDidMount = () =>{

    }
    //UPDATE STATE FROM PROPS
    static getDerivedStateFromProps(props, current_state) {
      // COMPUTE
      return null //STATE
    }
    // DEFAULT METHOD END /////////////////////////////
    ///////////////////////////////////////////////////




    //////////////////////////////////////////////////
    //  INNER METHOD    //////////////////////////////







    // INNER METHOD END   /////////////////////////////
    ///////////////////////////////////////////////////



    

    //////////////////////////////////////////////////
    //  RENDER METHOD   //////////////////////////////
    buildContent = () =>{
        var innerContent = null;
        var submenu = this.props._submenu;
        if(this.props._submenu   ===""){
          innerContent = <AdminSelector listSelector={this.state.listSelector}></AdminSelector>;
        }else{
          innerContent = <TreeListSplit explorerItem={this.state.listSelector.find(element => element.name === submenu)}></TreeListSplit>;
        }


      return(innerContent);
    }

    // RENDER METHOD END //////////////////////////////
    ///////////////////////////////////////////////////

    render() {
        var content = this.buildContent();
    
        return (
          <div className="Adminpage View">
              {content}
          </div>
        );
    }
   
}
 // END CLASS  //////////////////////////////////////////////////////




////////////////////////////////////////////////////////////////////
//////////////            REDUX              ///////////////////////
////////////////////////////////////////////////////////////////////
const mapStateToProps = (state) => {
  return {
    _submenu:state.appReducer.submenu,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Adminpage);